<header class="header text-format">
    <div class="rectangle-header-disconnected-sale">
        <svg class="rectangle-header-disconnected-sale-desktop" width="830" height="250" viewBox="0 0 830 250" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.56" x="287.237" y="-431" width="837.549" height="837.549" rx="120" transform="rotate(45 287.237 -431)" fill="#4A154B"/>
        </svg>    
        <svg class="rectangle-header-disconnected-sale-mobile" width="360" height="101" viewBox="0 0 360 101" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.56" x="185.237" y="-1048" width="837.549" height="837.549" rx="87" transform="rotate(45 185.237 -1048)" fill="#4A154B"/>
        </svg>                    
    </div>
    <div class="header-info window-padding d-flex-column">
        <div class="logo-card">
            <img src="../../../../assets/images/serasa-expirian-logo.png" class="logo">
        </div>
        <div class="d-flex-column text-header-card">
            <p class="text-header-size">Vamos começar</p>
        </div>
        <div class="step-container d-flex-row justify-content-between">
            <div class="step-card d-flex-column align-center">
                <i class="step-card-icon text-icon-size step-completed">1</i>
                <p class="text-icon-size">Informe seus dados</p>
            </div>
            <div class="step-card d-flex-column align-center">
                <i class="step-card-icon text-icon-size" 
                [ngClass]="{
                    'step-completed': this.headerStep === headerStepEnum.PAYMENT || this.headerStep === headerStepEnum.SUCCESS
                }">
                    2
                </i>
                <p class="text-icon-size">Pagamento</p>
            </div>
            <div class="step-card d-flex-column align-center">
                <i class="step-card-icon text-icon-size"
                [ngClass]="{
                    'step-completed': this.headerStep === headerStepEnum.SUCCESS
                }">
                    3
                </i>
                <p class="text-icon-size">Confirmação</p>
            </div>
        </div>
    </div>
</header>
